import styled from "styled-components";

export const StyledTransferWrapper = styled.div`
  position: relative;
  .create-transfer {
    position: absolute;
    top: 83px;
    right: 0;
    button {
      height: 55px;
    }
    @media screen and (max-width: 992px) {
      left: 0;
      right: inherit;
    }
    @media screen and (max-width: 576px) {
      top: 75px;
    }
  }
  
  .transfer-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;
    @media screen and (max-width: 992px) {
      padding-top: 95px;
    }
    @media screen and (max-width: 599px) {
      grid-template-columns: 100%;
    }
  }
  
  .transfer-table {
    &__head, &__row {
      grid-template-columns: repeat(2, minmax(250px, 1fr)) repeat(2, minmax(150px, .8fr)) repeat(4, minmax(150px, 1fr)) minmax(220px, 1fr) minmax(185px, 200px);
    }
    &__actions {
      button[border="danger"] {
        color: #fc344a;
      }
      & > div {
        display: grid;
        grid-template-columns: 100%;
        grid-gap: 10px;
      }
    }
    @media screen and (max-width: 992px) {
      min-width: auto;
      overflow-x: inherit;
      &__head {
        display: none;
      }
      &__row {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid #E5E5E5;
        & > div {
          padding-top: 20px;
          &:before {
            display: block;
          }
        }
      }
      &__actions, &__note {
        grid-column-start: 1;
        grid-column-end: 3;
      }
      &__actions {
        & > div {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
      &__actions, &__note {
        grid-column-end: 1;
      }
    }
  }
`;